import * as XLSX from "xlsx";
import moment from "moment";

interface ExportToExcelArgs {
  data: Array<Record<string, any>>;
  fileName: string;
  selectedKeys?: string[];
}

const exportToExcel = ({ data, fileName, selectedKeys }: ExportToExcelArgs) => {
  if (data.length === 0) return;

  const formattedDate = moment().format("DD-MM-YYYY");
  const finalFileName = `${fileName}_${formattedDate}.xlsx`;

  const headers = selectedKeys ? selectedKeys : Object.keys(data[0]);

  const formattedData = data.map((item) => {
    return headers.reduce(
      (acc, key) => {
        if (key in item) {
          acc[key] = item[key];
        }
        return acc;
      },
      {} as Record<string, any>,
    );
  });

  const ws = XLSX.utils.json_to_sheet(formattedData, {
    header: headers,
  });

  // Adjust column widths based on the data length (max length for each column)
  const columnWidths = headers.map((header) => {
    const maxLength = Math.max(
      header.length, // Header length
      ...data.map((item) => item[header]?.toString().length || 0), // Data length for each column
    );
    return { wch: maxLength + 2 }; // Add some padding for visibility
  });

  ws["!cols"] = columnWidths;

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
  XLSX.writeFile(wb, finalFileName);
};

export default exportToExcel;
